var News = {
  // btn01用のオブジェクト

  sliderLen: undefined,

  init:function () {
    this.scrollEffect();
  },

  scrollEffect: function () {
    $('.js-p-about-scroll-effect').scrollingEffects({
      threshold_rate:0.2,
      onEnter:function(e){
        if(e.direction === 'down'){
          $(this).addClass('is-active');
          // $(this).css('background-color','blue');
        }else{
          // $(this).css('background-color','blue');
        }
      },
      onLeave:function(e){
        // $(this).css('background-color','transparent');
      },
      entering:function(e){
        // $(this).width(e.rate*400);
      },
    });
  }

};



module.exports = News;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_about.js
// module id = 14
// module chunks = 0